<div title="Rental agreement status: {{ displayName() }}">
  @switch (status()) {
    @case (0) {
      <span
        class="badge rounded-pill bg-light border border-success text-success fw-bolder align-middle"
        style="font-size: 16px">
        <i class="fa-solid fa-file-lines fa-fw"></i>
        {{ displayName() }}</span
      >
    }
    @case (1) {
      <span class="badge rounded-pill text-bg-success border border-success align-middle" style="font-size: 16px">
        <i class="fa-regular fa-circle-check fa-fw"></i>
        {{ displayName() }}
      </span>
    }
    @case (2) {
      <span
        class="badge rounded-pill bg-light border border-secondary text-secondary fw-bolder align-middle"
        style="font-size: 16px">
        <i class="fa-solid fa-file-invoice-dollar fa-fw"></i>
        {{ displayName() }}
      </span>
    }
    @case (3) {
      <span
        class="badge rounded-pill bg-light border border-secondary text-secondary fw-bolder align-middle"
        style="font-size: 16px">
        <i class="fas fa-money-bill-transfer fa-fw"></i>
        {{ displayName() }}
      </span>
    }
    @case (4) {
      <span
        class="badge rounded-pill bg-light border border-secondary text-secondary fw-bolder align-middle"
        style="font-size: 16px">
        <i class="fas fa-money-bill-transfer fa-fw"></i>
        {{ displayName() }}
      </span>
    }
    @default {
      <span
        class="badge rounded-pill bg-light border border-secondary text-secondary align-middle"
        style="font-size: 16px"
        >{{ displayName() }}</span
      >
    }
  }
</div>
